import React from 'react';

import { DestructiveModal } from '@capintel/component-lib/destructive-modal';
import { Stack } from '@capintel/component-lib/stack';

import ReducedComparison from '@/types/reduced-comparison';
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import notification from '@/utils/notification';

type Props = {
  comparisons: ReducedComparison[];
  show: boolean;
  isDeleting: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

class DeleteComparisonsModal extends React.PureComponent<Props> {
  onConfirm = () => {
    const { onConfirm, comparisons } = this.props;

    onConfirm().then(() => {
      notification.success(formatMessage('DeleteComparisonsModal.DeleteSuccess', { count: comparisons.length }));
    });
  };

  render() {
    const { comparisons, isDeleting, show, onCancel } = this.props;

    return (
      <DestructiveModal
        open={show}
        onOpenChange={open => !open && onCancel()}
        title={formatMessage('DeleteComparisonsModal.Title', { count: comparisons.length })}
        content={
          <Stack gap="150">
            <FormattedMessage id="DeleteComparisonsModal.Body" values={{ count: comparisons.length }} />
            <ul>
              {comparisons.map(comparison => (
                <li key={comparison._id} data-private data-dd-privacy="mask">
                  {comparison.name}
                </li>
              ))}
            </ul>
            <FormattedMessage id="DeleteComparisonsModal.Confirmation" />
          </Stack>
        }
        confirmButtonText={formatMessage(`DeleteComparisonsModal.${isDeleting ? 'ConfirmingButton' : 'ConfirmButton'}`, { count: comparisons.length })}
        cancelButtonText={formatMessage('Common.Cancel')}
        onConfirm={this.onConfirm}
        onCancel={onCancel}
        loading={isDeleting}
      />
    );
  }
}

export default DeleteComparisonsModal;
